import TokenForm from '../../../components/edge/TokenForm.jsx';
import InlineComponent from './inlineComponent.jsx';

module.exports = class edgeTokenForm extends InlineComponent {
  define() {
    this.component = TokenForm;
  }
};
